import {Listbox as ArkListbox, createListCollection} from '@ark-ui/react/listbox'
import './index.less'
import {useCallback, useRef} from 'react'

const COLUMN_ITEM_HEIGHT = 24

export const TimePickerPanelColumn = ({allOptions, disabledOptions, label, selectedValue, allowReselect, onSelect}) => {
	const refContent = useRef(null)

	const stringValue = String(selectedValue)

	const collection = createListCollection({
		items: allOptions.map(timeValue => ({
			label: String(timeValue).padStart(2, '0'),
			value: String(timeValue),
			disabled: disabledOptions.includes(timeValue),
		})),
	})

	const hasSelectedValue = collection.items.some(timeOption => timeOption.value === stringValue)
	const handleOptionClick = timeOption => {
		if (!allowReselect || timeOption.disabled || timeOption.value !== stringValue) return

		onSelect(Number(timeOption.value))
	}

	// Display the column at a scroll position that is relatively "convinient" to the selected item
	const scrollToIndex = useCallback(({index, getElement}) => {
		const contentElement = refContent.current
		const itemElement = getElement()

		if (!contentElement || !itemElement) return

		const top = index * COLUMN_ITEM_HEIGHT
		contentElement.scrollTo({top})
	}, [])

	return (
		<ArkListbox.Root
			collection={collection}
			value={hasSelectedValue ? [stringValue] : []}
			defaultHighlightedValue={hasSelectedValue ? stringValue : undefined}
			onSelect={details => onSelect(Number(details.value))}
			selectionMode="single"
			loopFocus
			scrollToIndexFn={scrollToIndex}
		>
			<ArkListbox.Label className="no-first-letter-uppercase">{label}</ArkListbox.Label>
			<ArkListbox.Content ref={refContent}>
				{collection.items.map(timeOption => (
					<ArkListbox.Item item={timeOption} key={timeOption.value} highlightOnHover onClick={() => handleOptionClick(timeOption)}>
						<ArkListbox.ItemText>{timeOption.label}</ArkListbox.ItemText>
					</ArkListbox.Item>
				))}
			</ArkListbox.Content>
		</ArkListbox.Root>
	)
}
